{
  "ActionType": {
    "Email": "Email",
    "FortiGate": "FortiGate",
    "Syslog": "Syslog"
  },
  "ActivationCodeSource": {
    "FromExisting": "From Existing",
    "FromPending": "From Pending"
  },
  "AgentVmsConnectionStatus": {
    "VmsInvalid": "VMS Invalid",
    "VmsNotAvailable": "VMS Not Available",
    "VmsValid": "VMS Valid"
  },
  "AssetCategory": {
    "ControllersCategory": "Controllers",
    "IotCategory": "IoT",
    "NetworkAssetsCategory": "Network Assets"
  },
  "AssetGroupType": {
    "And": "And",
    "AssetList": "Asset List",
    "Filter": "Filter",
    "Function": "Function",
    "IpList": "IP List",
    "IpRange": "IP Range",
    "Or": "Or",
    "Segment": "Segment",
    "TypeFamily": "Type Family"
  },
  "AssetLayoutSection": {
    "AuditLog": "Audit Log",
    "DetailsFromVms": "Details From Vms",
    "DevicesAndDrives": "Devices And Drives",
    "EndOfLife": "End Of Life",
    "Ethernet": "Ethernet",
    "Foxboro": "Foxboro",
    "General": "General",
    "Hardware": "Hardware",
    "HartIP": "Hart IP",
    "HotFixes": "Hot Fixes",
    "IEC61850": "IEC 61850",
    "InstalledSoftware": "Installed Software",
    "InterfaceStatus": "Interface Status",
    "Memory": "Memory",
    "NessusScanInformation": "Nessus Scan Information",
    "OS": "OS",
    "Overview": "Overview",
    "Profinet": "Profinet",
    "ProfinetCM": "Profinet CM",
    "Project": "Project",
    "SecurityLog": "Security Log",
    "Sources": "Sources",
    "System": "System",
    "USBDevices": "USB Devices"
  },
  "AssetSourceType": {
    "ActiveOt": "Active OT",
    "Csv": "CSV",
    "ErSpan": "ERSPAN",
    "IotConnector": "IoT Connector",
    "Local": "Local",
    "Nessus": "Nessus",
    "NetworkMapper": "Network Mapper",
    "OtAgent": "OT Agent",
    "Pcap": "PCAP",
    "ProjectFile": "Project File",
    "Scd": "SCD",
    "Sensor": "Sensor",
    "Unknown": "Unknown",
    "UserDefined": "User Defined"
  },
  "AssetType": {
    "AccessControlSystem": "Access Control System",
    "AccessControlSystem_other": "Access Control Systems",
    "AccessPoint": "Wireless Access Point",
    "AccessPoint_other": "Wireless Access Points",
    "Actuator": "Actuator",
    "Actuator_other": "Actuators",
    "BackplaneModule": "Backplane Module",
    "BackplaneModule_other": "Backplane Modules",
    "BarcodeScanner": "Barcode Scanner",
    "BarcodeScanner_other": "Barcode Scanners",
    "Bms": "BMS Controller",
    "Bms_other": "BMS Controllers",
    "Camera": "Camera",
    "Camera_other": "Cameras",
    "Cnc": "CNC",
    "Cnc_other": "CNCs",
    "Controller": "Controller",
    "Controller_other": "Controllers",
    "Converter": "Converter",
    "Converter_other": "Converters",
    "Cp": "Communication Module",
    "Cp_other": "Communication Modules",
    "DataLogger": "Data Logger",
    "DataLogger_other": "Data Loggers",
    "Dcs": "DCS",
    "Dcs_other": "DCSs",
    "DomainController": "Domain Controller",
    "DomainController_other": "Domain Controllers",
    "Drive": "Drive",
    "Drive_other": "Drives",
    "Eng": "Engineering Station",
    "Eng_other": "Engineering Stations",
    "FieldDevice": "Field Device",
    "FieldDevice_other": "Field Devices",
    "FileServer": "File server",
    "FileServer_other": "File servers",
    "Firewall": "Firewall",
    "Firewall_other": "Firewalls",
    "Gateway": "Gateway",
    "Gateway_other": "Gateways",
    "Historian": "Historian",
    "Historian_other": "Historians",
    "Hmi": "HMI",
    "Hmi_other": "HMIs",
    "Hub": "Hub",
    "Hub_other": "Hubs",
    "HvacModule": "HVAC Module",
    "HvacModule_other": "HVAC Modules",
    "Ied": "IED",
    "Ied_other": "IEDs",
    "IndustrialGateway": "Industrial Gateway",
    "IndustrialGateway_other": "Industrial Gateways",
    "IndustrialNetworkDevice": "Industrial Network Device",
    "IndustrialNetworkDevice_other": "Industrial Network Devices",
    "IndustrialPrinter": "Industrial Printer",
    "IndustrialPrinter_other": "Industrial Printers",
    "IndustrialRouter": "Industrial Router",
    "IndustrialRouter_other": "Industrial Routers",
    "IndustrialSensor": "Industrial Sensor",
    "IndustrialSensor_other": "Industrial Sensors",
    "IndustrialSwitch": "Industrial Switch",
    "IndustrialSwitch_other": "Industrial Switches",
    "Inverter": "Inverter",
    "Inverter_other": "Inverters",
    "Io": "I/O Module",
    "Io_other": "I/O Modules",
    "Iot": "IoT",
    "Iot_other": "IoT",
    "LightingControl": "Lighting Control",
    "LightingControl_other": "Lighting Controls",
    "MedicalDevice": "Medical Device",
    "MedicalDevice_other": "Medical Devices",
    "Mobile": "Mobile",
    "Mobile_other": "Mobiles",
    "NetworkDevice": "Network Device",
    "NetworkDevice_other": "Network Devices",
    "OtDevice": "OT Device",
    "OtDevice_other": "OT Devices",
    "OtServer": "OT Server",
    "OtServer_other": "OT Servers",
    "OtWorkstation": "OT Workstation",
    "OtWorkstation_other": "OT Workstations",
    "Panel": "Panel",
    "Panel_other": "Panels",
    "Plc": "PLC",
    "Plc_other": "PLCs",
    "PowerMeter": "Power Meter",
    "PowerMeter_other": "Power Meters",
    "PowerSupply": "Power Supply",
    "PowerSupply_other": "Power Supplies",
    "Printer": "Printer",
    "Printer_other": "Printers",
    "Projector": "Projector",
    "Projector_other": "Projectors",
    "Radio": "Radio",
    "Radio_other": "Radios",
    "Relay": "Relay",
    "Relay_other": "Relays",
    "RemoteIo": "Remote I/O",
    "RemoteIo_other": "Remote I/Os",
    "Repeater": "Repeater",
    "Repeater_other": "Repeaters",
    "Robot": "Robot",
    "Robot_other": "Robot",
    "Router": "Router",
    "Router_other": "Routers",
    "Rtu": "RTU",
    "Rtu_other": "RTUs",
    "SecurityAppliance": "Security Appliance",
    "SecurityAppliance_other": "Security Appliances",
    "SerialEthernetBridge": "Serial-Ethernet Bridge",
    "SerialEthernetBridge_other": "Serial-Ethernet Bridges",
    "Server": "Server",
    "Server_other": "Servers",
    "SmartHub": "Smart Hub",
    "SmartHub_other": "Smart Hubs",
    "SmartSensor": "Smart Sensor",
    "SmartSensor_other": "Smart Sensors",
    "SmartTv": "Smart TV",
    "SmartTv_other": "Smart TVs",
    "StorageDevice": "Storage Device",
    "StorageDevice_other": "Storage Devices",
    "Switch": "Switch",
    "Switch_other": "Switches",
    "Tablet": "Tablet",
    "Tablet_other": "Tablets",
    "TenableEm": "Tenable EM",
    "TenableEm_other": "Tenable EMs",
    "TenableIcp": "Tenable ICP",
    "TenableIcp_other": "Tenable ICPs",
    "TenableSensor": "Tenable Sensor",
    "TenableSensor_other": "Tenable Sensors",
    "ThreeDPrinter": "3D Printer",
    "ThreeDPrinter_other": "3D Printers",
    "Unknown": "Endpoint",
    "Unknown_other": "Endpoints",
    "Ups": "UPS",
    "Ups_other": "UPSs",
    "VideoManagementSystem": "Video Management System",
    "VideoManagementSystem_other": "Video Management Systems",
    "VirtualServer": "Virtual Server",
    "VirtualServer_other": "Virtual Servers",
    "VirtualWorkstation": "Virtual Workstation",
    "VirtualWorkstation_other": "Virtual Workstations",
    "VoipDevice": "VOIP Device",
    "VoipDevice_other": "VOIP Devices",
    "WebServer": "Web Server",
    "WebServer_other": "Web Servers",
    "Workstation": "Workstation",
    "Workstation_other": "Workstations"
  },
  "AuthProvidersType": {
    "Ad": "AD",
    "Ldap": "LDAP",
    "LocalDB": "Local DB",
    "Saml": "SAML",
    "Unknown": "Unknown"
  },
  "BacnetObjType": {
    "AnalogInputObject": "Analog Input Object",
    "AnalogOutputObject": "Analog Output Object",
    "DeviceObject": "Device Object"
  },
  "BasicCredentialsTypes": {
    "Bachmann": "Bachmann",
    "FoxTls": "Fox TLS",
    "Moxa": "Moxa",
    "Sel": "Sel",
    "SicamA8000": "SICAM A8000",
    "Ssh": "SSH",
    "Wmi": "WMI"
  },
  "BasicCredentialsWithRoleTypes": {
    "AbbRtu500": "ABB RTU500"
  },
  "BlockType": {
    "BlockABBAC800Applications": "Block ABB AC 800 Applications",
    "BlockABBAC800ClearLatchedStatus": "Block ABB AC 800 Clear Latched Status",
    "BlockABBAC800CompilingStation": "Block ABB AC 800 Compiling Station",
    "BlockABBAC800Configuration": "Block ABB AC 800 Configuration",
    "BlockABBAC800DomainSize": "Block ABB AC 800 Domain Size",
    "BlockABBAC800GlobalData": "Block ABB AC 800 Global Data",
    "BlockABBAC800IOForcedField": "Block ABB AC 800 I/O Forced Field",
    "BlockABBAC800ProgramInvocationState": "Block ABB AC 800 Program Invocation State",
    "BlockABBAC800ProjectPath": "Block ABB AC 800 Project Path",
    "BlockABBAC800Signature": "Block ABB AC 800 Signature",
    "BlockABBAC800Tag": "Block ABB AC 800 Tag",
    "BlockAbbRTU500File": "Block ABB RTU500 File",
    "BlockAbbRTU500Object": "Block ABB RTU500 Object",
    "BlockAbbRTU500Parameter": "Block ABB RTU500 Parameter",
    "BlockAbbRTU500Project": "Block ABB RTU500 Project",
    "BlockAbbRTU500RCD": "Block ABB RTU500 RCD",
    "BlockAbbRTU500RCDFileVersion": "Block ABB RTU500 RCD File Version",
    "BlockAbbRTU500RCDHash": "Block ABB RTU500 Hash",
    "BlockAbbRTU500Section": "Block ABB RTU500 Section",
    "BlockAbbRTU500SubSection": "Block ABB RTU500 Sub Section",
    "BlockAbbRTU500Title": "Block ABB RTU500 Title",
    "BlockCipForce": "Block CIP Force",
    "BlockCipIoForcing": "Block CIP I/O Forcing",
    "BlockCipProgram": "Block CIP Program",
    "BlockCipPrograms": "Block CIP Programs",
    "BlockCipProject": "Block CIP Project",
    "BlockCipRoutine": "Block CIP Routine",
    "BlockCipRoutines": "Block CIP Routines",
    "BlockCipSfcForcing": "Block CIP SFC Forcing",
    "BlockCipTag": "Block CIP Tag",
    "BlockCipTagBit": "Block CIP Tag Bit",
    "BlockCipTags": "Block CIP Tags",
    "BlockCipTask": "Block CIP Task",
    "BlockCipTasks": "Block CIP Tasks",
    "BlockCode": "Block Code",
    "BlockConcept": "Block Concept",
    "BlockDB": "Block DB",
    "BlockDataFile": "Block Data File",
    "BlockDiagnostics": "Block Diagnostics",
    "BlockDirectory": "Block Directory",
    "BlockFB": "Block FB",
    "BlockFC": "Block FC",
    "BlockFaceCategory": "Block Face Category",
    "BlockFaceNodeId": "Block Face Node ID",
    "BlockFacePlc": "Block Face PLC",
    "BlockFaceSection": "Block Face Section",
    "BlockFaceTag": "Block Face Tag",
    "BlockFoxDriver": "Block Fox Driver",
    "BlockFoxDriversProject": "Block Fox Drivers Project",
    "BlockIEC61850Attribute": "Block IEC 61850 Attribute",
    "BlockIEC61850FC": "Block IEC 61850 FC",
    "BlockIEC61850Function": "Block IEC 61850 Function",
    "BlockIEC61850LD": "Block IEC 61850 LD",
    "BlockIEC61850LN": "Block IEC 61850 LN",
    "BlockIEC61850StationName": "Block IEC 61850 Station Name",
    "BlockMELSECConfiguration": "Block MELSEC Configuration",
    "BlockMELSECProgram": "Block MELSEC Program",
    "BlockMetadata": "Block Metadata",
    "BlockOB": "Block OB",
    "BlockP2CodeLinesAdded": "Block P2 Code Lines Added",
    "BlockP2CodeLinesUploaded": "Block P2 Code Lines Uploaded",
    "BlockP2DeletedProgram": "Block P2 Deleted Program",
    "BlockP2DeletedRange": "Block P2 Deleted Range",
    "BlockP2Point": "Block P2 Point",
    "BlockP2PointStatusChanged": "Block P2 Point Status Changed",
    "BlockP2PointValueChanged": "Block P2 Point Value Changed",
    "BlockP2Program": "Block P2 Program",
    "BlockS7IOForcedField": "Block S 7 I/O Forced Field",
    "BlockSDB": "Block SDB",
    "BlockSFB": "Block SFB",
    "BlockSFC": "Block SFC",
    "BlockSiprotec4": "Block SIPROTEC 4",
    "BlockSrtpClear": "Block SRTP Clear",
    "BlockSrtpCodeFilesDownloaded": "Block SRTP Code Files Downloaded",
    "BlockSrtpCodeFilesUploaded": "Block SRTP Code Files Uploaded",
    "BlockSrtpSetState": "Block SRTP Set State",
    "BlockSystem": "Block System",
    "BlockToyopucProgram": "Block TOYOPUC Program",
    "BlockToyopucProject": "Block TOYOPUC Project",
    "BlockUnknown": "Block Unknown",
    "BlockYokogawaSection": "Block Yokogawa Section"
  },
  "ChangeType": {
    "BlockAdded": "Block Added",
    "BlockChangeUnknown": "Block Change Unknown",
    "BlockDataChanged": "Block Data Changed",
    "BlockDeleted": "Block Deleted",
    "BlockUnchanged": "Block Unchanged"
  },
  "ChannelType": {
    "ChannelA": "Channel A",
    "ChannelB": "Channel B",
    "Unknown": "Unknown"
  },
  "ComponentType": {
    "Backplane": "Backplane",
    "Events": "Events",
    "Unknown": "Unknown",
    "Vulnerabilities": "Vulnerabilities"
  },
  "ConcurentWorkersOptions": {
    "Ten": "Ten",
    "Thirty": "Thirty",
    "Twenty": "Twenty"
  },
  "ConnectionStatus": {
    "Connected": "Connected",
    "Disconnected": "Disconnected"
  },
  "ConnectionType": {
    "AbbAC800Backplane": "ABB AC 800 Backplane",
    "AbbRTU500Backplane": "ABB RTU500 Backplane",
    "BachmannBackplane": "Bachmann Backplane",
    "BacnetBackplane": "BACnet Backplane",
    "Cip1768Backplane": "Cip 1768 Backplane",
    "CipBackplane": "CIP Backplane",
    "CipControlNet": "CIP Control Net",
    "CipDhPlus": "CIP DH Plus",
    "CipFlexBus": "CIP Flex Bus",
    "CipIp": "CIP IP",
    "ConceptBackplane": "Concept Backplane",
    "CotpBackplane": "COTP Backplane",
    "Direct": "Direct",
    "GEPacBackplane": "GE PAC Backplane",
    "MelsecBackplane": "MELSEC Backplane",
    "RocBackplane": "ROC Backplane",
    "S7Addr": "S7 Addr",
    "S7PlusAddr": "S7 Plus Addr",
    "SicamBackplane": "SICAM Backplane",
    "ToyopucBackplane": "TOYOPUC  Backplane",
    "UmasBackplane": "UMAS Backplane",
    "Unknown": "Unknown"
  },
  "CoreOsVersion": {
    "Centos7": "CentOS 7",
    "Ol8": "OL8",
    "Windows": "Windows"
  },
  "CredentialSchemaType": {
    "BasicSchema": "Basic Schema",
    "BasicSchemaWithRole": "Basic Schema With Role",
    "PasswordOnlySchema": "Password-Only Schema",
    "SnmpV2Schema": "SNMP V2 Schema",
    "SnmpV3Schema": "SNMP V3 Schema"
  },
  "CredentialsCategory": {
    "ItCredentials": "IT Credentials",
    "OtCredentials": "OT Credentials"
  },
  "CredentialsType": {
    "AbbRtu500": "ABB RTU500",
    "Bachmann": "Bachmann",
    "Concept": "Concept",
    "FoxTls": "Fox TLS",
    "Moxa": "Moxa",
    "Sel": "Sel",
    "SicamA8000": "SICAM A8000",
    "SicamSnmp": "SICAM SNMP",
    "Siprotec5": "SIPROTEC 5",
    "SnmpV2": "SNMP V2",
    "SnmpV3": "SNMP V3",
    "Ssh": "SSH",
    "Wmi": "WMI"
  },
  "Criticality": {
    "HighCriticality": "High",
    "LowCriticality": "Low",
    "MediumCriticality": "Medium",
    "NoneCriticality": "None"
  },
  "CustomFieldValueType": {
    "HyperLink": "Hyperlink",
    "PlainText": "Plain Text"
  },
  "DiscoveryQueryTypes": {
    "AssetDiscoveryType": "Asset Discovery Type",
    "DnsType": "DNS Type",
    "IcsDiscovery": "ICS Discovery",
    "InactiveAssetProbe": "Inactive Asset Probe",
    "PortScanAssetEnrichment": "Port Scan Asset Enrichment",
    "PortScanQueryType": "Port Scan Query Type",
    "SubnetsDiscovery": "Subnets Discovery"
  },
  "DisplayName": {
    "ABBNCDeviceID": "ABB NC Device ID",
    "AMSNetworkID": "AMS Network ID",
    "ActiveProject": "Active Project",
    "ActiveProjectCreationDate": "Active Project Creation Date",
    "ActiveProjectModificationDate": "Active Project Modification Date",
    "AdditionalIP": "Additional IP",
    "AdditionalIPs": "Additional IPs",
    "AdditionalMAC": "Additional MAC",
    "AdditionalMACs": "Additional MACs",
    "Address": "Address",
    "AddressEth1": "Address Eth1",
    "AppFirmware": "App Firmware",
    "Architecture": "Architecture",
    "AuditLog": "Audit Log",
    "BACnetDatabaseRevision": "BACnet Database Revision",
    "BACnetInstanceID": "BACnet Instance ID",
    "BACnetNetworkNumber": "BACnet Network Number",
    "BACnetObjectType": "BACnet Object Type",
    "BACnetProfileName": "BACnet Profile Name",
    "BIOSMajor": "BIOS Major",
    "BIOSMinor": "BIOS Minor",
    "BIOSSerial": "BIOS Serial",
    "BIOSVersion": "BIOS Version",
    "BLNName": "BLN Name",
    "Backplane": "Backplane",
    "BackplaneType": "Backplane Type",
    "BacnetApplicationSoftware": "BACnet Application Software",
    "BaseProject": "Base Project",
    "BatteryStatus": "Battery Status",
    "Baudrate": "Baud rate",
    "BinLib": "Bin Lib",
    "BinLibType1": "Bin Lib Type 1",
    "BinLibType2": "Bin Lib Type 2",
    "BoardHealth": "Board Health",
    "Boot": "Boot",
    "BootFirmware": "Boot Firmware",
    "BootFirmwareBuild": "Boot Firmware Build",
    "BootProjectName": "Boot Project Name",
    "BootTimeCreated": "Boot Time Created",
    "BootVersionNameAndPartNumber": "Boot Version Name and Part Number",
    "BrandID": "Brand ID",
    "BuildNumber": "Build Number",
    "BuildTime": "Build Time",
    "BuildType": "Build Type",
    "BuildVersion": "Build Version",
    "CEEState": "CEE State",
    "CPU": "CPU",
    "CPUFreeLowAlarm": "CPU Free Low Alarm",
    "CPUFreeLowLowAlarm": "CPU Free Low Low Alarm",
    "CPUID": "CPU ID",
    "CPUIDVariant": "CPU-ID Variant",
    "CPUIdleTime": "CPU Idle Time",
    "CPULoad": "CPU Load (%)",
    "CPURevision": "CPU Revision",
    "CPUSpeedMhz": "CPU Speed (Mhz)",
    "CPUType": "CPU Type",
    "CardState": "Card State",
    "CardType": "Card Type",
    "CodeandDataSeparate": "Code and Data Separate",
    "CodeandDataTogether": "Code and Data Together",
    "Command": "Command",
    "Comment": "Comment",
    "Comments": "Comments",
    "CommunicationConfigurationVersion": "Communication Configuration Version",
    "CompatibilityMode": "Compatibility Mode",
    "CompilerError": "Compiler Error",
    "CompilerStatus": "Compiler Status",
    "Components": "Components",
    "ComputerManufacturer": "Computer Manufacturer",
    "ComputerModel": "Computer Model",
    "ComputerName": "Computer Name",
    "ConfigurationChangeCounter": "Configuration Change Counter",
    "ConfigurationFile": "Configuration File",
    "ContractHour": "Contract Hour",
    "ControllerIndex": "Controller Index",
    "Copyright": "Copyright",
    "Criticality": "Criticality",
    "CustomerName": "CustomerName",
    "DCPTimestamp": "DCP Timestamp",
    "DHCPEnabled": "DHCP Enabled",
    "DNP3Address": "DNP3 Address",
    "DNSServer": "DNS Server",
    "Date": "Date",
    "DefaultGateway": "Default Gateway",
    "DefaultTaskCycTimeMs": "Default Task Cyc Time (ms)",
    "DefaultTemplate": "Default Template",
    "Description": "Description",
    "DeviceID": "Device ID",
    "DevicePorts": "Device Ports",
    "DeviceProfile": "Device Profile",
    "DeviceProfileCode": "Device Profile Code",
    "DeviceRevision": "Device Revision",
    "DeviceSpecificStatus": "Device-Specific Status",
    "DeviceStatus": "Device Status",
    "DeviceStatusCode": "Device Status Code",
    "DeviceType": "Device Type",
    "DevicesAndDrives": "Devices & Drives",
    "DirectIP": "Direct IP",
    "DirectIPs": "Direct IPs",
    "DirectMAC": "Direct MAC",
    "DirectMACs": "Direct MACs",
    "DiscontinuedDate": "Discontinued Date",
    "DisplayFirmwareVersion": "Display Firmware Version",
    "DisplayHardware": "Display Hardware",
    "DisplayOrderNumber": "Display Order Number",
    "Domain": "Domain",
    "DomainName": "Domain Name",
    "DownloadTime": "Download Time",
    "DownloadingPCName": "Downloading PC Name",
    "EndOfDay": "End Of Day",
    "EngineeringSoftware": "Engineering Software",
    "ExpandedDeviceType": "Expanded Device Type",
    "ExpansionCode": "Expansion Code",
    "ExtendedState": "Extended State",
    "ExtendedStatus": "Extended Status",
    "ExtendedStatusCode": "Extended Status Code",
    "FSTInstructionsPerCycle": "FST Instructions Per Cycle",
    "FabricationDate": "Fabrication Date",
    "FactoryBoot": "Factory Boot",
    "Family": "Family",
    "FirmwareBurnDate": "Firmware Burn Date",
    "FirmwareChecksum": "Firmware Checksum",
    "FirmwareComModule": "Firmware Com Module",
    "FirmwareDate": "Firmware Date",
    "FirmwareLoaderVersion": "Firmware Loader Version",
    "FirmwareNumber": "Firmware Number",
    "FirmwareTimeCreated": "Firmware Time Created",
    "FirmwareVersion": "Firmware Version",
    "FirstSeen": "First Seen",
    "FlashCapacity": "Flash Capacity",
    "FlashDiskSpaceFree": "Flash Disk Space Free",
    "FlashDiskSpaceUsed": "Flash Disk Space Used",
    "FlashFree": "Flash Free",
    "FlashStatus": "Flash Status",
    "FlashUsed": "Flash Used",
    "FloBoss107ModuleType": "FloBoss107 Module Type",
    "FoxID": "Fox ID",
    "FoxVersion": "Fox Version",
    "FramesPerSecond": "Frames per second",
    "FreeDataMemory": "Free Data Memory",
    "FreeIOMemory": "Free IO Memory",
    "FreePhysicalMemory": "Free Physical Memory",
    "FreeProgramMemory": "Free Program Memory",
    "FreeRetainData": "Free Retain Data",
    "FreeSystemData": "Free System Data",
    "FreeVirtualMemory": "Free Virtual Memory",
    "Gateway": "Gateway",
    "Group": "Group",
    "GroupName": "Group Name",
    "HARTUniversalRevision": "HART Universal Revision",
    "Hardware": "Hardware",
    "HardwareNumber": "Hardware Number",
    "HardwareOrderNumber": "Hardware Order Number",
    "HardwareRevision": "Hardware Revision",
    "HardwareState": "Hardware State",
    "HardwareVersion": "Hardware Version",
    "HostAddress": "Host Address",
    "HostID": "Host ID",
    "HostName": "Host Name",
    "Hostname": "Hostname",
    "Hotfixes": "Hot fixes",
    "IOICLoad": "IOIC Load (%)",
    "IP": "IP",
    "ImageVersion": "Image Version",
    "InstallDate": "Install Date",
    "InstallationTime": "Installation Time",
    "InstalledSoftware": "Installed Software",
    "KernelVersion": "Kernel Version",
    "KeyState": "Key State",
    "LCM": "LCM",
    "LMSize": "LM Size",
    "LMUsedSize": "LM Used Size",
    "LastCodeChange": "Last Code Change",
    "LastPowerDownTime": "Last Power Down Time",
    "LastPowerUpTime": "Last Power Up Time",
    "LastRestart": "Last Restart",
    "LastScanDuration": "Last Scan Duration",
    "LastSeen": "Last Seen",
    "LastStateUpdate": "Last State Update",
    "LastSuccessfulAuthenticatedScan": "Last Successful authenticated scan",
    "LastSuccessfulScan": "Last Successful Scan",
    "LastUpdate": "Last Update",
    "LinkLocalIP": "Link-Local IP",
    "Location": "Location",
    "LogicalAddress": "Logical Address",
    "LogicalCompatibilityStatus": "Logical Compatibility Status",
    "MAC": "MAC",
    "MMCSize": "MMC Size",
    "MMCUsedSize": "MMC Used Size",
    "ManufacturerID": "Manufacturer ID",
    "MemSize": "Mem Size",
    "MemUsedSize": "Mem Used Size",
    "MemoryCardSerial": "Memory Card Serial",
    "MemoryRetainSize": "Memory Retain Size",
    "MemoryRetainUsedSize": "Memory Retain Used Size",
    "MemorySize": "Memory Size",
    "MemorySizeCode": "Memory Size Code",
    "MemorySizeData": "Memory Size Data",
    "MemoryStatus": "Memory Status",
    "MemoryTotal": "Memory Total",
    "MemoryType": "Memory Type",
    "MemoryUsed": "Memory Used",
    "MeteringFirmware": "Metering Firmware",
    "MixedMemory": "Mixed Memory",
    "Model": "Model",
    "ModelName": "Model Name",
    "ModuleName": "Module Name",
    "ModuleSlot": "Module Slot",
    "ModuleSpecificData": "Module Specific Data",
    "ModuleVersion": "Module Version",
    "NSAP": "NSAP",
    "Name": "Name",
    "NameofVmsserver": "Name of Vms server",
    "Network": "Network",
    "NetworkSegments": "Network Segments",
    "NiagaraDevice": "Niagara Device",
    "NiagaraPlatformType": "Niagara Platform Type",
    "NiagaraVersion": "Niagara Version",
    "NodeId": "Node Id",
    "NonVolatileLargestMemoryBlock": "Non-Volatile Largest Memory Block",
    "NonVolatileMemory": "Non-Volatile Memory",
    "NonVolatileMemorySize": "Non-Volatile Memory Size",
    "NonVolatileMemoryUsed": "Non-Volatile Memory Used",
    "NumberOfProcessors": "Number of Processors",
    "Numberofstreams": "Number of streams",
    "OEMAddID": "OEM Add ID",
    "OEMCopyrightString": "OEM Copyright String",
    "OEMID": "OEM ID",
    "OS": "OS",
    "OSArchitecture": "OS Architecture",
    "OSName": "OS Name",
    "OSVersion": "OS Version",
    "OperatingMode": "Operating Mode",
    "OperatingModeCode": "Operating Mode Code",
    "OperatingSystem": "Operating System",
    "Options": "Options",
    "OrderNumber": "Order Number",
    "Organization": "Organization",
    "OverTemperatureThreshold": "Over Temperature Threshold",
    "PG5Licensee": "PG 5 Licensee",
    "PG5Version": "PG 5 Version",
    "PLCLocation": "PLC Location",
    "PLCName": "PLC Name",
    "PLCSource": "PLC Source",
    "PLCVersion": "PLC Version",
    "PackageVersion": "Package Version",
    "PairedDrop": "Paired Drop",
    "ParameterSet": "Parameter Set",
    "PartNumber": "Part Number",
    "Plant": "Plant",
    "PlantID": "Plant ID",
    "PlatformVersion": "Platform Version",
    "PrimaryEEPROMRevision": "Primary EEPROM Revision",
    "PrimaryHardwareDate": "Primary Hardware Date",
    "PrimaryHardwarePart": "Primary Hardware Part",
    "PrimaryHardwareRevision": "Primary Hardware Revision",
    "PrimaryROMAddress": "Primary ROM Address",
    "PrimaryfirmwareBuild": "Primary firmware Build",
    "ProductCode": "Product Code",
    "ProductID": "Product ID",
    "Profile": "Profile",
    "ProfileID": "Profile ID",
    "ProfileSpecificType": "Profile Specific Type",
    "Program1": "Program 1",
    "Program2": "Program 2",
    "Program3": "Program 3",
    "ProgramCRC": "Program CRC",
    "ProgramID": "Program ID",
    "ProjectComment": "Project Comment",
    "ProjectDate": "Project Date",
    "ProjectExportDate": "Project Export Date",
    "ProjectFileName": "Project File Name",
    "ProjectLastModifiedDate": "Project Last Modified Date",
    "ProjectName": "Project Name",
    "ProjectPassword": "Project Password",
    "ProjectPath": "Project Path",
    "ProjectSerialNumber": "Project Serial Number",
    "ProjectSignature": "Project Signature",
    "ProjectSoftwareRevision": "Project Software Revision",
    "ProjectSource": "Project Source",
    "ProjectUploader": "Project Uploader",
    "ProjectVersion": "Project Version",
    "PurdueLevel": "Purdue Level",
    "ROCSeries": "ROC Series",
    "Rack": "Rack",
    "ReaderDescription": "Reader Description",
    "ReaderName": "Reader Name",
    "RedundancyRoleState": "Redundancy Role State",
    "RedundancySyncState": "Redundancy Sync State",
    "Reference": "Reference",
    "Region": "Region",
    "RegisteredUser": "Registered User",
    "ReplacementProduct": "Replacement Product",
    "Resolution": "Resolution",
    "Revision": "Revision",
    "RiskScore": "Risk Score",
    "RobotSoftware": "Robot Software",
    "RobotSoftwareEdition": "Robot Software Edition",
    "Role": "Role",
    "RoleFlags": "Role Flags",
    "SSE": "SSE",
    "ScriptFile": "Script File",
    "SecurityLog": "Security Log",
    "Serial": "Serial",
    "SerialNumber": "Serial Number",
    "SerialPort1": "Serial Port 1",
    "SerialPort2": "Serial Port 2",
    "SerialPort3": "Serial Port 3",
    "SerialPort4": "Serial Port 4",
    "SerialPort5": "Serial Port 5",
    "SerialPort6": "Serial Port 6",
    "SerialPort7": "Serial Port 7",
    "SerialPort8": "Serial Port 8",
    "ServerType": "Server Type",
    "ServicePackMajor": "Service Pack Major",
    "ServicePackMinor": "Service Pack Minor",
    "Services": "Services",
    "Slot": "Slot",
    "SmartIOType": "Smart IO Type",
    "SnmpEnabled": "Snmp Enabled",
    "SoftFailState": "Soft Fail State",
    "SoftwareVersion": "Software Version",
    "Sources": "Sources",
    "SpEngine": "Sp Engine",
    "State": "State",
    "StationName": "Station Name",
    "StationNumber": "Station Number",
    "StationType": "Station Type",
    "SubnetMask": "Subnet Mask",
    "SwitchMode": "Switch Mode",
    "SystemAddressEth1": "System Address Eth1",
    "SystemError": "System Error",
    "SystemMode": "System Mode",
    "SystemRolloverForDoublePrecisionParameters": "System Rollover for Double Precision Parameters",
    "SystemTickMs": "System Tick (ms)",
    "Tags": "Tags",
    "TargetArchitecture": "Target Architecture",
    "Template": "Template",
    "TestModeOn": "Test Mode On",
    "Time": "Time",
    "TotalDataMemory": "Total Data Memory",
    "TotalIOMemory": "Total IO Memory",
    "TotalPhysicalMemory": "Total Physical Memory",
    "TotalVirtualMemory": "Total Virtual Memory",
    "TrendStorageCapacity": "Trend Storage Capacity",
    "TrendStorageUsage": "Trend Storage Usage",
    "Type": "Type",
    "USBDevices": "USB Devices",
    "Units": "Units",
    "Uptime": "Uptime",
    "UsedDataMemory": "Used Data Memory",
    "UsedIOMemory": "Used IO Memory",
    "UsedPhysicalMemory": "Used Physical Memory",
    "UsedVirtualMemory": "Used Virtual Memory",
    "VDaddress": "VD address",
    "VMName": "VM Name",
    "VMVersion": "VM Version",
    "Vendor": "Vendor",
    "VendorID": "Vendor ID",
    "VendorLifecycleStatus": "Vendor Lifecycle Status",
    "VersionNameandPartNumber": "Version Name and Part Number",
    "VolatileLargestBlock": "Volatile Largest Block",
    "VolatileMemory": "Volatile Memory",
    "VolatileMemorySize": "Volatile Memory Size",
    "VolatileMemoryUsed": "Volatile Memory Used",
    "WorstCPULoad": "Worst CPU Load (%)"
  },
  "EmPairingStatus": {
    "IcpConnected": "ICP Connected",
    "IcpDisconnected": "ICP Disconnected",
    "IcpPendingApproval": "ICP Pending Approval",
    "PreparingConnection": "Preparing Connection",
    "WaitingForIcpConnection": "Waiting For ICP Connection"
  },
  "EventCategoryType": {
    "ConfigurationEvents": "Configuration Events",
    "NetworkEvents": "Network Events",
    "NetworkThreats": "Network Threats",
    "NoCategory": "No Category",
    "ScadaEvents": "SCADA Events"
  },
  "EventGroupType": {
    "Activity": "Activity",
    "ControllerDetailsEvent": "Controller Details Event",
    "Dnp3Event": "DNP3 Event",
    "IDSGeneralEvent": "IDS General Event",
    "IDSSrcDstEvent": "IDS Src Dst Event",
    "IDSSrcEvent": "IDS Src Event",
    "IEC104": "IEC 104",
    "InactiveNetworkInterfaceEvent": "Inactive Network Interface Event",
    "IntrusionDetectionEvent": "Intrusion Detection Event",
    "MMSICCPEvent": "MMSICCP Event",
    "ModuleDetailsEvent": "Module Details Event",
    "NetworkEvent": "Network Event",
    "NetworkInterfaceEvent": "Network Interface Event",
    "PcEvent": "PC Event",
    "PortEvent": "Port Event",
    "RediscoveredAssetEvent": "Rediscovered Asset Event",
    "SnapshotEvent": "Snapshot Event",
    "TagEvent": "Tag Event"
  },
  "EventSchemaType": {
    "AssetSchema": "Asset Schema",
    "IntrusionDetectionSchema": "Intrusion Detection Schema",
    "NetworkSchema": "Network Schema",
    "PortSchema": "Port Schema",
    "ScheduleOnlySchema": "Schedule Only Schema",
    "SrcDstSchema": "Src Dst Schema",
    "TagDataSchema": "Tag Data Schema",
    "UnknownSchema": "Unknown Schema"
  },
  "EventStatus": {
    "CompletionError": "Completion Error",
    "CompletionSuccess": "Completion Success",
    "CompletionTimeout": "Completion Timeout",
    "CompletionUnexpectedTermination": "Completion Unexpected Termination",
    "CompletionUnknown": "Completion Unknown"
  },
  "ExclusionType": {
    "Activity": "Activity",
    "Asset": "Asset",
    "Conversation": "Conversation",
    "DNP3": "DNP3",
    "GOOSE": "GOOSE",
    "IEC104": "IEC 104",
    "IEC61850": "IEC 61850",
    "IntrusionDetection": "Intrusion Detection",
    "IpConflict": "IP Conflict",
    "OpenPort": "Open Port",
    "Scans": "Scans",
    "TagWrite": "Tag Write",
    "Unknown": "Unknown",
    "UsbChange": "USB Change"
  },
  "ExprOp": {
    "And": "And",
    "Between": "Between",
    "Contains": "Contains",
    "Equal": "Equal to",
    "Greater": "Greater than",
    "GreaterEqual": "Greater than or equal to",
    "In": "In",
    "Less": "Less than",
    "LessEqual": "Less than or equal to",
    "Like": "Like",
    "NotBetween": "Not Between",
    "NotContains": "Not Contains",
    "NotEqual": "Not Equal",
    "NotIn": "Not In",
    "NotLike": "Not Like",
    "Or": "Or",
    "SubnetContainsEqual": "Subnet Contains Equal"
  },
  "FeedType": {
    "NessusPluginSet": "Nessus Plugin Set",
    "Pii": "PII",
    "SuricataRuleSet": "Suricata Rule Set"
  },
  "FieldFunction": {
    "Avg": "Avg",
    "AvgDays": "Avg Days",
    "Count": "Count",
    "CountDistinct": "Count Distinct",
    "Divide": "Divide",
    "Max": "Max",
    "Min": "Min",
    "Multiply": "Multiply",
    "RoundMult10": "Round Mult 10",
    "Sum": "Sum",
    "TruncDay": "Trunc Day",
    "TruncHour": "Trunc Hour",
    "TruncMonth": "Trunc Month",
    "TruncWeek": "Trunc Week",
    "TruncYear": "Trunc Year",
    "Unnest": "Unnest"
  },
  "FindingStatus": {
    "Active": "Active",
    "Resolved": "Resolved",
    "Resurfaced": "Resurfaced"
  },
  "FirewallOpType": {
    "AssetDiscoveryType": "Asset Discovery Type",
    "BpScanType": "BP Scan Type",
    "CharacteristicsType": "Characteristics Type",
    "IcsDiscovery": "ICS Discovery",
    "IdentificationType": "Identification Type",
    "InactiveAssetProbe": "Inactive Asset Probe",
    "NbstatQueryType": "NetBIOS Query Type",
    "NessusBasicScanType": "Nessus Basic Scan Type",
    "PingType": "Ping Type",
    "PortScanAssetEnrichment": "Port Scan Asset Enrichment",
    "PortScanQueryType": "Port Scan Query Type",
    "RunStatusType": "Run Status Type",
    "SnapshotType": "Snapshot Type",
    "SnmpType": "SNMP Type",
    "SubnetsDiscovery": "Subnets Discovery",
    "WmiType": "WMI Type",
    "WmiUsbType": "WMI USB Type"
  },
  "GooseAnomalyType": {
    "confrev_change": "Confrev change",
    "sqnum_mismatch": "Sqnum mismatch",
    "stnum_mismatch": "Stnum mismatch"
  },
  "HardwareState": {
    "Active": "Active",
    "Discontinued": "Discontinued",
    "EndOfLife": "End Of Life",
    "UnknownState": "Unknown State"
  },
  "IcpEmPairingStatus": {
    "BadCredentialsError": "Bad Credentials Error",
    "CantGetTargetVersionError": "Can’t Get Target Version Error",
    "CertificateMismatchError": "Certificate Mismatch Error",
    "Connected": "Connected",
    "DisconnectedError": "Disconnected Error",
    "HostUnreachableError": "Host Unreachable Error",
    "InternalServerError": "Internal Server Error",
    "NoPairing": "No Pairing",
    "PendingEmApproval": "Pending EM Approval",
    "TryingToConnect": "Trying To Connect",
    "UnsupportedTargetVersionError": "Unsupported Target Version Error",
    "WaitingForCertificateApproval": "Waiting For Certificate Approval"
  },
  "IcpEmUpdateType": {
    "ApplicationUpdate": "Application Update",
    "SecurityPatch": "Security Patch"
  },
  "IcpUpdateStatus": {
    "Failed": "Failed",
    "Success": "Success",
    "Unknown": "Unknown",
    "Updating": "Updating"
  },
  "IemMonitoredNetworkField": {
    "category": "Category",
    "globalDescription": "Network Description",
    "globalName": "Network Name",
    "id": "Id",
    "subnet": "Subnet"
  },
  "IotConnectionMethod": {
    "RemoteAgent": "Remote Agent",
    "RemoteApi": "Remote API"
  },
  "IotConnectorStatus": {
    "Connected": "Connected",
    "Disconnected": "Disconnected",
    "NotAvailable": "Not Available",
    "SecureModeFailure": "Secure Mode Failure",
    "UnknownFailure": "Unknown Failure"
  },
  "IotConnectorType": {
    "Agent": "Agent",
    "Exacq": "Exacq",
    "Genetec": "Genetec",
    "Milestone": "Milestone",
    "MobotixCamera": "Mobotix Camera"
  },
  "IotConnectorWebProtocol": {
    "HTTP": "HTTP",
    "HTTPS": "HTTPS"
  },
  "ItQueryTypes": {
    "ArpType": "ARP Type",
    "NbstatQueryType": "NetBIOS Query Type",
    "NessusBasicScanType": "Nessus Basic Scan Type",
    "SnmpType": "SNMP Type",
    "WmiType": "WMI Type",
    "WmiUsbType": "WMI USB Type"
  },
  "JobStatus": {
    "Failure": "Failure",
    "Pending": "Pending",
    "Running": "Running",
    "Success": "Success"
  },
  "LicenseStatus": {
    "Active": "Active",
    "AssetCountExceeded": "Asset Count Exceeded",
    "MaintenanceExpired": "Maintenance Expired",
    "SubscriptionExpired": "Subscription Expired",
    "Uninitialized": "Uninitialized",
    "UnknownLicenseStatus": "Unknown License Status",
    "WaitingForActivation": "Waiting For Activation"
  },
  "LicenseType": {
    "Perpetual": "Perpetual",
    "Subscription": "Subscription",
    "UnknownLicenseType": "Unknown License Type"
  },
  "LogLevel": {
    "debug": "Debug",
    "error": "Error",
    "info": "Info",
    "warn": "Warn"
  },
  "MappingRate": {
    "FiftyPorts": "Fifty Ports",
    "FiveHundredPorts": "Five Hundred Ports",
    "FivePorts": "Five Ports",
    "HundredPorts": "Hundred Ports",
    "OnePort": "One Port",
    "TenPorts": "Ten Ports",
    "ThousandPorts": "Thousand Ports",
    "TwoPorts": "Two Ports"
  },
  "MonitoredNetworkCategory": {
    "Custom": "Custom IP Ranges",
    "Default": "Default IP Ranges"
  },
  "MonitoredNetworkField": {
    "category": "Type",
    "globalDescription": "Global Description",
    "globalName": "Global Name",
    "id": "ID",
    "isEnabled": "Monitored",
    "localDescription": "Description",
    "localName": "Network Name",
    "subnet": "CIDR"
  },
  "NessusUserScanCredentialsMode": {
    "DontUse": "Do not use credentials",
    "UseAll": "Try all available credentials",
    "UseSpecific": "Use only specific credentials"
  },
  "NetworkAreaSelectField": {
    "networkAreaDescription": "Network Area Description",
    "networkAreaId": "Network Area Id",
    "networkAreaManaged": "Network Area Managed",
    "networkAreaName": "Network Area Name",
    "networkAreaNetworks": "Network Area Networks",
    "networkAreaOtAgents": "Network Area Ot Agents",
    "networkAreaReportedSources": "Network Area Reported Sources",
    "networkAreaSensors": "Network Area Sensors",
    "networkAreaSupportActive": "Network Area Support Active"
  },
  "NetworkGroupType": {
    "PortFunction": "Port Function",
    "PortList": "Port List",
    "ProtocolFunction": "Protocol Function",
    "ProtocolList": "Protocol List"
  },
  "NetworkHostsSummaryDirection": {
    "destination": "Destination",
    "source": "Source"
  },
  "OpType": {
    "ArpType": "ARP Type",
    "AssetDiscoveryType": "Asset Discovery Type",
    "BpScanType": "BP Scan Type",
    "CharacteristicsType": "Characteristics Type",
    "DnsType": "DNS Type",
    "IcsDiscovery": "ICS Discovery",
    "IdentificationType": "Identification Type",
    "InactiveAssetProbe": "Inactive Asset Probe",
    "NbstatQueryType": "NetBIOS Query Type",
    "NessusBasicScanType": "Nessus Basic Scan Type",
    "PingType": "Ping Type",
    "PortScanAssetEnrichment": "Port Scan Asset Enrichment",
    "PortScanQueryType": "Port Scan Query Type",
    "RunStatusType": "Run Status Type",
    "SnapshotType": "Snapshot Type",
    "SnmpType": "SNMP Type",
    "SubnetsDiscovery": "Subnets Discovery",
    "Unknown": "Unknown",
    "WmiType": "WMI Type",
    "WmiUsbType": "WMI USB Type"
  },
  "OpenPortsSource": {
    "ActiveQueries": "Active Queries",
    "Conversations": "Conversations",
    "NNM": "NNM",
    "Nessus": "Nessus",
    "OtAgent": "OT Agent",
    "PortMapping": "Port Mapping",
    "UnknownSource": "Unknown Source"
  },
  "OtAgentAction": {
    "AbortScan": "Abort Scan",
    "Approve": "Approve",
    "LaunchScan": "Launch Scan",
    "RollbackUpdate": "Rollback Update",
    "Update": "Update"
  },
  "OtAgentScanResult": {
    "Completed": "Completed",
    "Failed": "Failed"
  },
  "OtAgentStatus": {
    "Connected": "Connected",
    "Disconnected": "Disconnected",
    "ManuallyRegistered": "Manually Registered",
    "PendingApproval": "Pending Approval",
    "PendingConfiguration": "Pending Configuration",
    "PreparingConnection": "Preparing Connection",
    "Scanning": "Scanning",
    "Updating": "Updating",
    "WaitingForConnection": "Waiting For Connection"
  },
  "OtQueryTypes": {
    "BpScanType": "BP Scan Type",
    "CharacteristicsType": "Characteristics Type",
    "IdentificationType": "Identification Type",
    "RunStatusType": "Run Status Type",
    "SnapshotType": "Snapshot Type"
  },
  "OtdScanSelectField": {
    "createdAt": "Created At",
    "credentials": "Credentials",
    "description": "Description",
    "id": "Id",
    "monitoredNetworks": "Monitored Networks",
    "name": "Name",
    "networkAreas": "Network Areas",
    "otdScanCreatedAt": "Otd Scan Created At",
    "otdScanCredentials": "Otd Scan Credentials",
    "otdScanDescription": "Otd Scan Description",
    "otdScanId": "Otd Scan Id",
    "otdScanMonitoredNetworks": "Otd Scan Monitored Networks",
    "otdScanName": "Otd Scan Name",
    "otdScanNetworkAreas": "Otd Scan Network Areas",
    "otdScanOrigins": "Otd Scan Origins",
    "otdScanSchedule": "Otd Scan Schedule",
    "otdScanScheduleEnabled": "Otd Scan Schedule Enabled",
    "otdScanUpdatedAt": "Otd Scan Updated At",
    "schedule": "Schedule",
    "scheduleEnabled": "Schedule Enabled",
    "updatedAt": "Updated At"
  },
  "PasswordOnlyCredentialsTypes": {
    "Concept": "Concept",
    "Siprotec5": "SIPROTEC 5"
  },
  "PauseBetweenProbesOptions": {
    "OneSecond": "One Second",
    "ThreeSeconds": "Three Seconds",
    "TwoSeconds": "Two Seconds"
  },
  "PluginHitStatus": {
    "Mitigated": "Mitigated",
    "Outstanding": "Outstanding",
    "Resurfaced": "Resurfaced"
  },
  "PluginHits": {
    "assetId": "Asset ID",
    "mitigatedAt": "Mitigated At",
    "mitigationDuration": "Mitigation Duration",
    "output": "Output",
    "pluginId": "Plugin ID",
    "port": "Port",
    "protocol": "Protocol",
    "severity": "Severity",
    "status": "Status",
    "svcName": "SVC Name",
    "time": "Time"
  },
  "PluginSeverity": {
    "Critical": "Critical",
    "High": "High",
    "Info": "Info",
    "Low": "Low",
    "Medium": "Medium"
  },
  "PluginSource": {
    "NNM": "NNM",
    "Nessus": "Nessus",
    "Tot": "TOT",
    "Unknown": "Unknown"
  },
  "PolicyEventType": {
    "Abb800xAClearLatchedStatus": "ABB 800xA Clear Latched Status",
    "Abb800xACodeDownload": "ABB 800xA Code Download",
    "Abb800xADeleteApplication": "ABB 800xA Delete Application",
    "Abb800xADeleteProject": "ABB 800xA Delete Project",
    "Abb800xAEnableWebServer": "ABB 800xA Enable Web Server",
    "Abb800xAFirmwareDownload": "ABB 800xA Firmware Download",
    "Abb800xAGoOnline": "ABB 800xA Go Online",
    "Abb800xAIoForcingDisable": "ABB 800xA I/O Forcing Disable",
    "Abb800xAIoForcingEnable": "ABB 800xA I/O Forcing Enable",
    "Abb800xARedundancyResetBackup": "ABB 800xA Redundancy Reset Backup",
    "Abb800xARedundancySwitchPrimary": "ABB 800xA Redundancy Switch Primary",
    "Abb800xAReplaceIOForces": "ABB 800xA Replace I/O Forces",
    "AbbMasterbus300CodeDownload": "ABB MasterBus 300 Code Download",
    "AbbMasterbus300CodeUpload": "ABB MasterBus 300 Code Upload",
    "AbbMasterbus300EngStationConnect": "ABB MasterBus 300 Eng Station Connect",
    "ApogeeCodeDiffDownload": "Apogee Code Diff Download",
    "ApogeeCodeDownload": "Apogee Code Download",
    "ApogeeCodeUpload": "Apogee Code Upload",
    "ApogeePlcColdstart": "Apogee PLC Coldstart",
    "ApogeeProgramReportUpload": "Apogee Program Report Upload",
    "ApogeeSetPointStatus": "Apogee Set Point Status",
    "ArpScan": "ARP Scan",
    "BachmannApplicationDownload": "Bachmann Application Download",
    "BachmannApplicationRun": "Bachmann Application Run",
    "BachmannApplicationStop": "Bachmann Application Stop",
    "BaselineDeviation": "Baseline Deviation",
    "BoschPsiConnect": "Bosch PSI Connect",
    "BoschPsiDisconnect": "Bosch PSI Disconnect",
    "BoschPsiDownloadConfig": "Bosch PSI Download Config",
    "BoschPsiReset": "Bosch PSI Reset",
    "Conversation": "Conversation",
    "ConversationCountSpikeDetected": "Conversation Count Spike Detected",
    "DNP3FcActivateConfiguration": "DNP3 FC Activate Configuration",
    "DNP3FcAuthenticateFile": "DNP3 FC Authenticate File",
    "DNP3FcCloseFile": "DNP3 FC Close File",
    "DNP3FcColdRestart": "DNP3 FC Cold Restart",
    "DNP3FcDeleteFile": "DNP3 FC Delete File",
    "DNP3FcDirectOperate": "DNP3 FC Direct Operate",
    "DNP3FcDirectOperateNoResponse": "DNP3 FC Direct Operate No Response",
    "DNP3FcDisableUnsolicitedResponses": "DNP3 FC Disable Unsolicited Responses",
    "DNP3FcEnableUnsolicitedResponses": "DNP3 FC Enable Unsolicited Responses",
    "DNP3FcInitializeApplication": "DNP3 FC Initialize Application",
    "DNP3FcInitializeData": "DNP3 FC Initialize Data",
    "DNP3FcOpenFile": "DNP3 FC Open File",
    "DNP3FcOperate": "DNP3 FC Operate",
    "DNP3FcSelect": "DNP3 FC Select",
    "DNP3FcStartApplication": "DNP3 FC Start Application",
    "DNP3FcStopApplication": "DNP3 FC Stop Application",
    "DNP3FcWarmRestart": "DNP3 FC Warm Restart",
    "DNP3iinAlreadyExecuting": "DNP3 IIN Already Executing",
    "DNP3iinBufferOverflow": "DNP3 IIN Buffer Overflow",
    "DNP3iinCorruptConfig": "DNP3 IIN Corrupt Config",
    "DNP3iinFcNotImplemented": "DNP3 IIN FC Not Implemented",
    "DNP3iinObjectUnknown": "DNP3 IIN Object Unknown",
    "DNP3iinParamError": "DNP3 IIN Param Error",
    "DataSpikeDetected": "Data Spike Detected",
    "DeltaVColdRestartDownload": "Delta V Cold Restart Download",
    "DeltaVControllerDownload": "Delta V Controller Download",
    "DeltaVEnterDebugMode": "Delta V Enter Debug Mode",
    "DeltaVFirmwareDownload": "Delta V Firmware Download",
    "DeltaVForceTransition": "Delta V Force Transition",
    "DeltaVLeaveDebugMode": "Delta V Leave Debug Mode",
    "DeltaVModuleDownload": "Delta V Module Download",
    "DeltaVModuleRun": "Delta V Module Run",
    "DeltaVModuleRunOnce": "Delta V Module Run Once",
    "DeltaVModuleStop": "Delta V Module Stop",
    "DeltaVPlcCommission": "Delta V PLC Commission",
    "DeltaVPlcDecommission": "Delta V PLC Decommission",
    "DeltaVSequenceReset": "Delta V Sequence Reset",
    "DeltaVSequenceStart": "Delta V Sequence Start",
    "DeltaVSequenceStop": "Delta V Sequence Stop",
    "DeltaVSetupDataDownload": "Delta V Setup Data Download",
    "DeltaVStepActivate": "Delta V Step Activate",
    "DeltaVStepDeactivate": "Delta V Step Deactivate",
    "DeltaVStepDisable": "Delta V Step Disable",
    "DeltaVStepEnable": "Delta V Step Enable",
    "DeltaVSwitchOver": "Delta V Switch Over",
    "FirmwareVersionChange": "Firmware Version Change",
    "FtpFailedLogin": "FTP Failed Login",
    "FtpSuccessfulLogin": "FTP Successful Login",
    "GOOSEConfRevChange": "GOOSE Conf Rev Change",
    "GOOSESqNumMismatch": "GOOSE Sq Num Mismatch",
    "GOOSEStNumMismatch": "GOOSE St Num Mismatch",
    "GeCodeDownload": "GE Code Download",
    "GeCodeUpload": "GE Code Upload",
    "GeGoOnline": "GE Go Online",
    "GeMonitorMode": "GE Monitor Mode",
    "GePlcClear": "GE PLC Clear",
    "GePlcStart": "GE PLC Start",
    "GePlcStop": "GE PLC Stop",
    "GeProgrammerMode": "GE Programmer Mode",
    "HoneywellCodeDownload": "Honeywell Code Download",
    "HoneywellCodeUpload": "Honeywell Code Upload",
    "HoneywellForceDisable": "Honeywell Force Disable",
    "HoneywellForceEnable": "Honeywell Force Enable",
    "HoneywellPlcColdRestart": "Honeywell PLC Cold Restart",
    "HoneywellPlcStop": "Honeywell PLC Stop",
    "HoneywellPlcWarmRestart": "Honeywell PLC Warm Restart",
    "ICCPBilateralTableExchange": "ICCP Bilateral Table Exchange",
    "ICCPCreateDataSet": "ICCP Create Data Set",
    "IEC104ClockSynchronizationCommand": "IEC 104 Clock Synchronization Command",
    "IEC104CounterInterrogationCommand": "IEC 104 Counter Interrogation Command",
    "IEC104InterrogationCommand": "IEC 104 Interrogation Command",
    "IEC104ResetProcessCommand": "IEC 104 Reset Process Command",
    "IEC104StartDataTransfer": "IEC 104 Start Data Transfer",
    "IEC104StopDataTransfer": "IEC 104 Stop Data Transfer",
    "IEC104TestCommandWithTimeTag": "IEC 104 Test Command With Time Tag",
    "IEC61850SubscriptionFailure": "IEC 61850 Subscription Failure",
    "IEC61850UnauthorizedWrite": "IEC 61850 Unauthorized Write",
    "InactiveAssetFifteenMins": "Inactive Asset Fifteen Mins",
    "InactiveAssetFiveMins": "Inactive Asset Five Mins",
    "InactiveAssetOneDay": "Inactive Asset One Day",
    "InactiveAssetOneHour": "Inactive Asset One Hour",
    "InactiveAssetOneWeek": "Inactive Asset One Week",
    "InactiveAssetThirtyMins": "Inactive Asset Thirty Mins",
    "InactiveAssetThreeHours": "Inactive Asset Three Hours",
    "InactiveAssetTwelveHours": "Inactive Asset Twelve Hours",
    "IntrusionDetected": "Intrusion Detected",
    "IpConflict": "IP Conflict",
    "MelsecQCodeDownload": "MELSEC Q Code Download",
    "MelsecQCodeUpload": "MELSEC Q Code Upload",
    "MmsDefineNamedVariableList": "MMS Define Named Variable List",
    "MmsDeleteNamedVariableList": "MMS Delete Named Variable List",
    "ModbusExceptionIllegalDataAddress": "Modbus Exception Illegal Data Address",
    "ModbusExceptionIllegalDataValue": "Modbus Exception Illegal Data Value",
    "ModbusExceptionIllegalFunction": "Modbus Exception Illegal Function",
    "ModiconCodeDownload": "Modicon Code Download",
    "ModiconCodeUpload": "Modicon Code Upload",
    "ModiconFirmwareDownload": "Modicon Firmware Download",
    "ModiconFirmwareErase": "Modicon Firmware Erase",
    "ModiconFirmwareUpload": "Modicon Firmware Upload",
    "ModiconGoOnline": "Modicon Go Online",
    "ModiconHardwareConfigurationDownload": "Modicon Hardware Configuration Download",
    "ModiconPlcStart": "Modicon PLC Start",
    "ModiconPlcStop": "Modicon PLC Stop",
    "ModuleDisappeared": "Module Disappeared",
    "ModuleKeyStateChange": "Module Key State Change",
    "ModuleStateChange": "Module State Change",
    "NewAssetDiscovered": "New Asset Discovered",
    "NewModule": "New Module",
    "OpenPort": "Open Port",
    "RdpConnectionNoAuthentication": "RDP Connection No Authentication",
    "RdpConnectionWithAuthentication": "RDP Connection With Authentication",
    "RediscoveredAsset": "Rediscovered Asset",
    "RockwellCodeDownload": "Rockwell Code Download",
    "RockwellCodeEdit": "Rockwell Code Edit",
    "RockwellCodeUpload": "Rockwell Code Upload",
    "RockwellFirmwareDownload": "Rockwell Firmware Download",
    "RockwellGoOnline": "Rockwell Go Online",
    "RockwellIoForcingDisable": "Rockwell I/O Forcing Disable",
    "RockwellIoForcingEnable": "Rockwell I/O Forcing Enable",
    "RockwellModuleRestart": "Rockwell Module Restart",
    "RockwellPlcStart": "Rockwell PLC Start",
    "RockwellPlcStop": "Rockwell PLC Stop",
    "RockwellPlcTest": "Rockwell PLC Test",
    "RockwellProgramCreate": "Rockwell Program Create",
    "RockwellProgramDelete": "Rockwell Program Delete",
    "RockwellRename": "Rockwell Rename",
    "RockwellRoutineCreate": "Rockwell Routine Create",
    "RockwellRoutineDelete": "Rockwell Routine Delete",
    "RockwellRungDelete": "Rockwell Rung Delete",
    "RockwellSfcForcingDisable": "Rockwell SFC Forcing Disable",
    "RockwellSfcForcingEnable": "Rockwell SFC Forcing Enable",
    "RockwellTagCreate": "Rockwell Tag Create",
    "RockwellTagDelete": "Rockwell Tag Delete",
    "RockwellTaskCreate": "Rockwell Task Create",
    "RockwellTaskDelete": "Rockwell Task Delete",
    "SaiaCodeDownload": "Saia Code Download",
    "SaiaCodeUpload": "Saia Code Upload",
    "SaiaPlcColdRestart": "Saia PLC Cold Restart",
    "SaiaPlcStart": "Saia PLC Start",
    "SaiaPlcStop": "Saia PLC Stop",
    "SimaticCodeDelete": "SIMATIC Code Delete",
    "SimaticCodeDownload": "SIMATIC Code Download",
    "SimaticCodeUpload": "SIMATIC Code Upload",
    "SimaticFirmwareApply": "SIMATIC Firmware Apply",
    "SimaticFirmwareDownload": "SIMATIC Firmware Download",
    "SimaticFirmwareUpload": "SIMATIC Firmware Upload",
    "SimaticGoOnline": "SIMATIC Go Online",
    "SimaticHardwareConfigurationDownload": "SIMATIC Hardware Configuration Download",
    "SimaticHardwareConfigurationUpload": "SIMATIC Hardware Configuration Upload",
    "SimaticIoForcingDisable": "SIMATIC I/O Forcing Disable",
    "SimaticIoForcingEnable": "SIMATIC I/O Forcing Enable",
    "SimaticPlcStart": "SIMATIC PLC Start",
    "SimaticPlcStop": "SIMATIC PLC Stop",
    "SimaticReplaceIOForces": "SIMATIC Replace I/O Forces",
    "SimaticTagWrite": "SIMATIC Tag Write",
    "SnapshotDiff": "Snapshot Diff",
    "SynScan": "Syn Scan",
    "TelnetFailedLogin": "Telnet Failed Login",
    "TelnetLoginAttempt": "Telnet Login Attempt",
    "TelnetSuccessfulLogin": "Telnet Successful Login",
    "ToyopucCodeDownload": "TOYOPUC Code Download",
    "ToyopucCodeUpload": "TOYOPUC Code Upload",
    "ToyopucPlcResetStart": "TOYOPUC PLC Reset Start",
    "ToyopucPlcStart": "TOYOPUC PLC Start",
    "ToyopucPlcStop": "TOYOPUC PLC Stop",
    "UnauthorizedTagWrite": "Unauthorized Tag Write",
    "Unknown": "Unknown",
    "UsbChange": "USB Change",
    "YokogawaCodeDownload": "Yokogawa Code Download",
    "YokogawaDcsPause": "Yokogawa Dcs Pause",
    "YokogawaDcsStart": "Yokogawa Dcs Start",
    "YokogawaDcsStep": "Yokogawa Dcs Step",
    "YokogawaDcsStop": "Yokogawa Dcs Stop",
    "YokogawaFunctionBlockChange": "Yokogawa Function Block Change",
    "YokogawaSnapshotLoad": "Yokogawa Snapshot Load",
    "YokogawaSnapshotSave": "Yokogawa Snapshot Save",
    "YokogawaTagWrite": "Yokogawa Tag Write"
  },
  "PolicyFindingFilterField": {
    "activeHits": "Active Hits",
    "assetsCriticalities": "Assets Criticalities",
    "assetsFamilies": "Assets Families",
    "assetsLocations": "Assets Locations",
    "assetsModels": "Assets Models",
    "assetsPurdueLevels": "Assets Purdue Levels",
    "assetsTypes": "Assets Types",
    "assetsVendors": "Assets Vendors",
    "category": "Category",
    "dstAssets": "Dst Assets",
    "dstIps": "Dst Ips",
    "dstMacs": "Dst Macs",
    "dstNames": "Dst Names",
    "eventType": "Event Type",
    "firstHitTime": "First Hit Time",
    "id": "Id",
    "lastHitTime": "Last Hit Time",
    "mitreTactics": "Mitre Tactics",
    "mitreTechniques": "Mitre Techniques",
    "pluginId": "Plugin Id",
    "pluginName": "Plugin Name",
    "policyId": "Policy Id",
    "policyTitle": "Policy Title",
    "protocols": "Protocols",
    "resolvedOn": "Resolved On",
    "resolvedUser": "Resolved User",
    "severity": "Severity",
    "srcAssets": "Src Assets",
    "srcIps": "Src Ips",
    "srcMacs": "Src Macs",
    "srcNames": "Src Names",
    "status": "Status"
  },
  "PolicyLevel": {
    "High": "High",
    "Low": "Low",
    "Medium": "Medium",
    "None": "None"
  },
  "PortScanRange": {
    "Basic": "Basic",
    "FullSweep": "Full Sweep",
    "Lean": "Lean"
  },
  "PurdueLevel": {
    "Level0": "Level 0",
    "Level1": "Level 1",
    "Level2": "Level 2",
    "Level3": "Level 3",
    "Level4": "Level 4",
    "UnknownLevel": "Unknown Level"
  },
  "QueriesCategory": {
    "Discovery": "Discovery",
    "IT": "IT",
    "OT": "OT"
  },
  "QuerySource": {
    "AutoDiscovery": "Auto Discovery",
    "EventTriggered": "Event Triggered",
    "Passive": "Passive",
    "Periodic": "Periodic",
    "UserInitiated": "User Initiated"
  },
  "QueryStatus": {
    "Completed": "Completed",
    "Created": "Created",
    "Failed": "Failed",
    "Ongoing": "Ongoing",
    "Preparing": "Preparing",
    "Unknown": "Unknown"
  },
  "QueryTrigger": {
    "Manual": "Manual",
    "Periodic": "Periodic",
    "System": "System"
  },
  "RdpFailureCode": {
    "HybridRequiredByServerFailureCode": "Hybrid Required By Server Failure Code",
    "InconsistentFlagsFailureCode": "Inconsistent Flags Failure Code",
    "SslCertNotOnServerFailureCode": "SSL Cert Not On Server Failure Code",
    "SslNotAllowedByServerFailureCode": "SSL Not Allowed By Server Failure Code",
    "SslRequiredByServerFailureCode": "SSL Required By Server Failure Code",
    "SslWithUserAuthRequiredByServerFailureCode": "SSL With User Auth Required By Server Failure Code",
    "UnknownFailureCode": "Unknown Failure Code"
  },
  "RdpProtocol": {
    "Hybrid": "Hybrid",
    "HybridEx": "Hybrid Ex",
    "Rdp": "RDP",
    "Rdstls": "RDSTLS",
    "Ssl": "SSL"
  },
  "RecurringScheduleType": {
    "EveryDay": "Every Day",
    "Friday": "Friday",
    "Monday": "Monday",
    "MondayToFriday": "Monday To Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "Thursday": "Thursday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday"
  },
  "RelationshipDirection": {
    "Bidirectional": "Bidirectional",
    "From": "From",
    "To": "To"
  },
  "RelationshipType": {
    "AgentGateway": "Agent Gateway",
    "BACnet": "BACnet",
    "IoTConnectors": "IoT Connectors",
    "Nesting": "Nesting",
    "ProjectFile": "Project File",
    "SnmpCrawler": "SNMP Crawler"
  },
  "RemovableFlags": {
    "AssetsPendingDeletion": "Assets Pending Deletion",
    "IcpPairingRequestPendingApproval": "ICP Pairing Request Pending Approval",
    "OtAgentPendingApproval": "OT Agent Pending Approval",
    "SensorAwaitingFirstUse": "Sensor Awaiting First Use",
    "SensorPendingApproval": "Sensor Pending Approval",
    "SensorUpdatesAvailable": "Sensor Updates Available",
    "SoftLimit": "Soft Limit",
    "WaitingForEmCertApproval": "Waiting For EM Cert Approval"
  },
  "ResolutionType": {
    "Daily": "Daily",
    "Interval": "Interval"
  },
  "ReturnType": {
    "Boolean": "Boolean",
    "Float": "Float",
    "Integer": "Integer",
    "String": "String",
    "Time": "Time"
  },
  "RuleGroupType": {
    "RuleList": "Rule List"
  },
  "RunStatus": {
    "Alert": "Alert",
    "Backup": "Backup",
    "Fault": "Fault",
    "NoConfig": "No Config",
    "Running": "Running",
    "Stopped": "Stopped",
    "Test": "Test",
    "Unknown": "Unknown"
  },
  "ScanAction": {
    "Kill": "Kill",
    "Launch": "Launch",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop"
  },
  "ScheduleGroupType": {
    "Function": "Function",
    "IntervalGroup": "Interval Group",
    "RecurringGroup": "Recurring Group"
  },
  "SchemaType": {
    "AssetSchema": "Asset Schema",
    "IntrusionDetectionSchema": "Intrusion Detection Schema",
    "NetworkSchema": "Network Schema",
    "PortSchema": "Port Schema",
    "ScheduleOnlySchema": "Schedule-Only Schema",
    "SrcDstSchema": "Src Dst Schema",
    "TagDataSchema": "Tag Data Schema",
    "UnknownSchema": "Unknown Schema"
  },
  "SelectionStatus": {
    "Disabled": "Disabled",
    "Enabled": "Enabled",
    "Mixed": "Mixed"
  },
  "Sensitivity": {
    "High": "High",
    "Low": "Low",
    "Medium": "Medium"
  },
  "SensorActiveAction": {
    "Disable": "Disable",
    "Enable": "Enable"
  },
  "SensorActiveStatus": {
    "Disabled": "Disabled",
    "Enabled": "Enabled",
    "NotAvailable": "Not Available"
  },
  "SensorStatus": {
    "Connected": "Connected",
    "ConnectedUnauthenticated": "Connected Unauthenticated",
    "Disconnected": "Disconnected",
    "NoTunnel": "No Tunnel",
    "Paused": "Paused",
    "Pending": "Pending",
    "Updating": "Updating"
  },
  "SensorsBulkAction": {
    "DisableActive": "Disable Active",
    "EnableActive": "Enable Active",
    "Pause": "Pause",
    "Resume": "Resume",
    "Update": "Update"
  },
  "ServerStatus": {
    "BadCredentials": "Bad Credentials",
    "InProgress": "In Progress",
    "NoPermission": "No Permission",
    "Ok": "OK",
    "SessionsLimitExceeded": "Sessions Limit Exceeded",
    "UnknownError": "Unknown Error",
    "Unreachable": "Unreachable"
  },
  "SitesUserGroupsField": {
    "id": "ID",
    "rolesNames": "Roles Names",
    "siteId": "Site ID",
    "siteName": "Site Name",
    "status": "Status",
    "system": "System",
    "userGroupId": "User Group ID",
    "userGroupName": "User Group Name",
    "zonesNames": "Zones Names"
  },
  "SnapshotStatus": {
    "AuthenticationError": "Authentication Error",
    "DnsError": "DNS Error",
    "EmptyClientResponseError": "Empty Client Response Error",
    "HostUnreachableError": "Host Unreachable Error",
    "InternalError": "Internal Error",
    "LimitExceededError": "Limit Exceeded Error",
    "MultipleErrors": "Multiple Errors",
    "NetworkError": "Network Error",
    "NoAllowedClients": "No Allowed Clients",
    "NoPotentialClients": "No Potential Clients",
    "NoRoutesForClient": "No Routes For Client",
    "OpAllowedOnce": "Op Allowed Once",
    "ProtocolError": "Protocol Error",
    "Success": "Success",
    "TimeoutError": "Timeout Error"
  },
  "SnapshotTrigger": {
    "AutoDiscovery": "Auto Discovery",
    "EventTriggered": "Event Triggered",
    "Passive": "Passive",
    "Periodic": "Periodic",
    "UserInitiated": "User Initiated"
  },
  "SnmpV2CredentialsTypes": {
    "SnmpV2": "SNMP V2"
  },
  "SnmpV3AuthProtocol": {
    "MD5": "MD5",
    "NoAuth": "No Auth",
    "SHA": "SHA",
    "SHA224": "SHA-224",
    "SHA256": "SHA-256",
    "SHA384": "SHA-384",
    "SHA512": "SHA-512"
  },
  "SnmpV3CredentialsTypes": {
    "SicamSnmp": "SICAM SNMP",
    "SnmpV3": "SNMP V3"
  },
  "SnmpV3PrivProtocol": {
    "AES": "AES",
    "AES192": "AES-192",
    "AES192C": "AES-192 C",
    "AES256": "AES-256",
    "AES256C": "AES-256 C",
    "DES": "DES",
    "NoPriv": "No Priv"
  },
  "SnmpV3SecurityLevel": {
    "AuthNoPriv": "Auth No Priv",
    "AuthPriv": "Auth Priv",
    "NoAuthNoPriv": "No Auth No Priv"
  },
  "SortDirection": {
    "AscNullFirst": "Asc Null First",
    "AscNullLast": "Asc Null Last",
    "DescNullFirst": "Desc Null First",
    "DescNullLast": "Desc Null Last"
  },
  "SourceType": {
    "SourceLocal": "Source Local",
    "SourceOwn": "Source Own",
    "SourceRemote": "Source Remote"
  },
  "SpikeTimeFrame": {
    "FifteenMins": "Fifteen Mins",
    "FourHours": "Four Hours",
    "OneDay": "One Day",
    "OneHour": "One Hour",
    "OneMonth": "One Month",
    "OneWeek": "One Week",
    "TwelveHours": "Twelve Hours"
  },
  "StatusType": {
    "Disabled": "Disabled",
    "Enabled": "Enabled",
    "InvalidStatus": "Invalid Status",
    "Uninitialized": "Uninitialized"
  },
  "SwitchMode": {
    "BothPortsSameIp": "Both Ports Same IP",
    "DualIp": "Dual IP",
    "SecondPortDisabled": "Second Port Disabled"
  },
  "SystemShutdownType": {
    "Reboot": "Reboot",
    "Shutdown": "Shutdown"
  },
  "TagGroupType": {
    "AssetsTags": "Assets Tags"
  },
  "TagType": {
    "Bool": "Bool",
    "DInt": "D Int",
    "Float": "Float",
    "Int": "Int",
    "Long": "Long",
    "MultipleTagTypes": "Multiple Tag Types",
    "Short": "Short",
    "Unknown": "Unknown"
  },
  "ThoroughTestsType": {
    "No": "No",
    "Yes": "Yes"
  },
  "TimeFrame": {
    "custom": "Custom",
    "fifteenMinutes": "Fifteen Minutes",
    "fourHours": "Four Hours",
    "oneDay": "One Day",
    "oneHour": "One Hour",
    "oneMonth": "One Month",
    "oneWeek": "One Week",
    "twelveHours": "Twelve Hours"
  },
  "TunnelStatus": {
    "NoTunnel": "No Tunnel",
    "Paused": "Paused",
    "Pending": "Pending",
    "Running": "Running"
  },
  "UpdatableStatus": {
    "NonUpdatable": "Non-Updatable",
    "Undetermined": "Undetermined",
    "Updatable": "Updatable"
  },
  "UsbChange": {
    "Insertion": "Insertion",
    "Removal": "Removal"
  },
  "UserDefinedCriticality": {
    "HighCriticality": "High Criticality",
    "LowCriticality": "Low Criticality",
    "MediumCriticality": "Medium Criticality",
    "NoneCriticality": "No Criticality",
    "_RemoveUserDefinedValue": "Remove User-Defined Value"
  },
  "UserDefinedPurdueLevel": {
    "Level0": "Level 0",
    "Level1": "Level 1",
    "Level2": "Level 2",
    "Level3": "Level 3",
    "Level4": "Level 4",
    "UnknownLevel": "Unknown Level",
    "_RemoveUserDefinedValue": "Remove User-Defined Value"
  },
  "UserScanStatus": {
    "AbortedScanStatus": "Aborted",
    "CanceledScanStatus": "Canceled",
    "CancelingScanStatus": "Canceling",
    "CompletedScanStatus": "Completed",
    "EmptyScanStatus": "Empty (created but never executed)",
    "ImportedScanStatus": "Imported",
    "InitializingScanStatus": "Processing",
    "KillingScanStatus": "Killing",
    "PausedScanStatus": "Paused",
    "PausingScanStatus": "Pausing",
    "PendingScanStatus": "Pending",
    "ProcessingScanStatus": "Processing",
    "QueuedScanStatus": "Processing",
    "ResumingScanStatus": "Resuming",
    "RunningScanStatus": "Running",
    "StoppedScanStatus": "Stopped",
    "StoppingScanStatus": "Stopping",
    "UnknownScanStatus": "Unknown"
  },
  "VerbosityType": {
    "Normal": "Normal",
    "Verbose": "Verbose"
  },
  "VprLevel": {
    "Critical": "Critical",
    "High": "High",
    "Low": "Low",
    "Medium": "Medium",
    "None": "None"
  }
}